import { useDispatch, useSelector } from "react-redux"
import { getUserLocation, UserLocationSelector } from "shared/reducers/profileSlice"
import { useCallback, useEffect } from "react"

const useCurrency = (): {
    costCoef: number,
    sign: string,
    isFetchingUserLocation: boolean,
    convertCurrency: (amount: number) => string,
    isRub: boolean,
} => {
    const dispatch = useDispatch()
    const {
        userLocation,
        isFetchingUserLocation,
    } = useSelector(UserLocationSelector)
    const isRub = userLocation?.country?.toLowerCase() === 'russia'
    const costCoef = isRub ? 1 : 5
    const sign = isRub ? '₽' : '₸'

    useEffect(() => {
        if (!userLocation && !isFetchingUserLocation) {
            dispatch(getUserLocation())
        }
    }, [])

    const convertCurrency = useCallback((amount: number) => {
        return `${amount * costCoef}${sign}`
    }, [costCoef, sign])

    return {
        costCoef,
        sign,
        isRub,
        isFetchingUserLocation,
        convertCurrency,
    }
}

export default useCurrency;import { useDispatch, useSelector } from "react-redux"
import { getUserLocation, UserLocationSelector } from "shared/reducers/profileSlice"
import { useCallback, useEffect } from "react"

const useCurrency = (): {
    costCoef: number,
    sign: string,
    isFetchingUserLocation: boolean,
    convertCurrency: (amount: number) => string,
    isRub: boolean,
} => {
    const dispatch = useDispatch()
    const {
        userLocation,
        isFetchingUserLocation,
    } = useSelector(UserLocationSelector)
    const isRub = userLocation?.country?.toLowerCase() === 'russia'
    const costCoef = isRub ? 1 : 5
    const sign = isRub ? '₽' : '₸'

    useEffect(() => {
        if (!userLocation && !isFetchingUserLocation) {
            dispatch(getUserLocation())
        }
    }, [])

    const convertCurrency = useCallback((amount: number) => {
        return `${amount * costCoef}${sign}`
    }, [costCoef, sign])

    return {
        costCoef,
        sign,
        isRub,
        isFetchingUserLocation,
        convertCurrency,
    }
}

export default useCurrency;